export class DonationConfig {
  attestationThresholdAmount: number = 0;
  attestationHeader: string = '';
  attestationFooter: string = '';
  attestationPrefix: string = '';
}
